/**
 * XPEN-3152: which of the firm's cards paid an invoice.
 *
 * A card receipt names the card it was paid with in json.PaymentBank; its
 * supplier is the merchant, not the card's. A card statement has no
 * PaymentBank, and its supplier is the card's own supplier.
 *
 * Ids reach the page in two shapes: a card's _id comes from /c_card/ through
 * json_util, as { $oid: "…" }, while PaymentBank.value is a plain string.
 * Both are unwrapped before comparing: String({ $oid }) is "[object Object]"
 * and would match every card.
 */

const plainId = (id) => id?.$oid || id;

export function findInvoiceCreditCard(creditCards, invoice) {
    const paymentBank = invoice?.json?.PaymentBank;
    const paymentCardId = plainId(paymentBank?.value) || plainId(paymentBank?._id);
    if (paymentCardId) {
        const card = creditCards?.find((c) => String(plainId(c._id)) === String(paymentCardId));
        if (card) return card;
    }
    const supplierId = invoice?.json?.ListSupplier?.[0]?.Index;
    if (supplierId === undefined) return undefined;
    return creditCards?.find((c) => String(plainId(c.supplier?._id)) === String(plainId(supplierId)));
}
